/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type LandingPageCurriculumResponse = {
    id?: number;
    bootCampCategory?: LandingPageCurriculumResponse.bootCampCategory;
    sequence?: number;
    part?: string;
    title?: string;
    description?: string;
    contents?: string;
};

export namespace LandingPageCurriculumResponse {

    export enum bootCampCategory {
        ALL = 'ALL',
        SEBFE = 'SEBFE',
        SEBBE = 'SEBBE',
        UUB = 'UUB',
        GMB = 'GMB',
        DOB = 'DOB',
        PMB = 'PMB',
        BEB = 'BEB',
        AIB = 'AIB',
    }


}

